<router-outlet></router-outlet>
<ngx-ui-loader [text]="loadingMessageService.text$ | async"></ngx-ui-loader>
